<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div class="row">
                        <div class="col-12">
                            <modulo-comentario
                                module="ViolenciaViolacaoDireito"
                                :id="violacaodedireito.id"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["violacaodedireito"],
    data() {
        return {};
    },
};
</script>
